import { connect, useDispatch } from "react-redux";
import "./Dashboard.scss";
import Sidemenu from "../DesignSystem/Sidemenu/Sidemenu";
import Header from "../Header/Header";
import { useIntl } from "react-intl";
import Button from "../DesignSystem/Button/Button";
import { USER_STATUS } from "../../utils/constants";
import "../DesignSystem/Card/Card.scss";
import { ROUTE_REGISTRATIONS } from "../app/routes";
import { push } from "connected-react-router";
import { useEffect } from "react";
import { fetchRegisteredUsers } from "../../store/thunks/registrations";
import Card from "../DesignSystem/Card/Card";

export default connect(
	(state) => ({
		...state.registrations,
	}),
	{}
)(({ registeredUsers }) => {
	const { formatMessage } = useIntl();
	const dispatch = useDispatch();

	useEffect(() => {
		if (!registeredUsers.length) {
			dispatch(fetchRegisteredUsers());
		}
	}, [registeredUsers]);

	const navigateToRegistrations = () => {
		dispatch(
			push({
				pathname: ROUTE_REGISTRATIONS,
			})
		);
	};

	return (
		<div className="dashboard-container">
			<Header />
			<div className="wrapper flex direction-row justify-content-between align-items-start">
				<Sidemenu />
				<div className="dashboard-content flex direction-col justify-content-start align-items-start">
					<div className="text text-header--7 text-left">Dashboard</div>

					<div className="dashboard-content-body mt-16 flex direction-col justify-content-start align-items-start">
						<div className="card-container flex direction-row justify-content-between align-items-start">
							<div className="mt-24" style={{ width: "100%" }}>
								<div className="row">
									<div className="col-lg-4">
										<Card>
											<div className="text text-body-2 text-bold text-left">
												{formatMessage({ id: "dashboard.registration.cardTitle" })}
											</div>
											<div className="row mt-16">
												<div className="">
													<div className="text text-header--2">{registeredUsers.length}</div>
													<div className="text text-body--4">
														{formatMessage({
															id: "dashboard.registration.registeredUsers",
														})}
													</div>
												</div>
											</div>
											<div className="flex direction-col justify-content-end">
												<Button
													label="dashboard.registration.gotoRegistrations"
													className="mt-16 button-tertiary"
													showRightIcon={true}
													onClick={navigateToRegistrations}
												/>
											</div>
										</Card>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
});
